import React from "react";
import { withRouter, Switch } from "react-router-dom";
import ReactSVG from "react-svg";
import PropTypes from "prop-types";
import cx from "classnames";
import Proxy from "components/HOC/ContentTabProxy";
import Tab from "./Tab";
import KnowledgeBase from "./KnowledgeBase";
import Comments from "./Comments/index";
import Mailing from "./Mailing/Mailing";
import AppealHistory from "../Ordering/common/HistoryTab";

import { RouteWithTabs, createCheckPropsFunction /*, getTabConfig*/ } from "helpers";
import { connect } from "react-redux";
import { resetAppealHistory } from "actions/session";
import { resetKnowledgeBase } from "actions/knowledgeBase";
import permissions, { checkPermissions } from "config/permissions";
import baseService from "../../services/BaseService";
import Loader from "../../components/Loader";

const COMMENT_LOCK_SOURCE = "comment";

// const DEFAULT_TABS_WIDTH = "width-500";

const mapStateToProps = state => {
    return {
        mailing: state.appeal.mailingUpTo,
    };
};

const mapDispatchToProps = dispatch => ({
    resetAppealHistory: () => dispatch(resetAppealHistory()),
    resetKnowledgeBase: () => dispatch(resetKnowledgeBase()),
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class TabContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            allowableTabs: null, 
            allowebleLabels: null, 
            isLoading: true,
			// iconClass: 'qwarter',
			// tabsWidth: localStorage.getItem("appeals_tabsWidth") === null ? DEFAULT_TABS_WIDTH : localStorage.getItem('appeals_tabsWidth'), // should be true by default
			// tabsOpened: localStorage.getItem("appeals_tabsOpened") === null ? true : localStorage.getItem('appeals_tabsOpened') === 'true', // should be true by default
        };
    }
    componentDidMount() {
        this.resetPreviousTabState(this.props.match.params.tab);
        this.getAllowableTabs();
    }

    componentDidUpdate(prevProps) {
        const isPropChanged = createCheckPropsFunction(prevProps, this.props);
        if (isPropChanged("mailing") && this.state.allowableTabs) {
            return this.setState(prevState => ({
                ...prevState,
                allowableTabs: this.addCount(prevState.allowableTabs, "mailing"),
            }));
        }
        if (isPropChanged("match.params.appealId") && prevProps.match.params.appealId) {
            this.getAllowableTabs();
        }
        if (isPropChanged("match.params.tab") && prevProps.match.params.tab) {
            this.resetPreviousTabState(prevProps.match.params.tab);
        }
    }

    componentWillUnmount() {
        this.setState({ allowableTabs: null, allowebleLabels: null, isLoading: true });
    }

    addCount(allowableTabs, counter) {
        const newCount = this.props[counter];
        return allowableTabs.map(item => {
            if (item.label === counter && newCount > item.countTotal) {
                return { ...item, countTotal: newCount, availabilityOfNew: false };
            }
            return item;
        });
    }

    getAllowableTabs = async () => {
        this.setState({ allowableTabs: null, allowebleLabels: null, isLoading: true });
        const { appealId } = this.props.match.params;
        const { tabsOpened } = this.state;
        const conf = await baseService.get("appeal_subtabs", { pathParams: { appealId } });

        if (conf.success) {
            let sortedConf = conf.result.sort((a, b) => (a.orderNum > b.orderNum ? 1 : -1));

            if (!checkPermissions(permissions.UserOperations.action_clientPartViewKnowledgeBase)) {
                sortedConf = sortedConf.filter(({ label }) => label !== "knowledgeBase");
            }
            if (!checkPermissions(permissions.EmailOperations.action_viewEmail)) {
                sortedConf = sortedConf.filter(({ label }) => label !== "mailing");
            }

            // const isSomeCountAvailable = conf && conf.result.some(item => item.countTotal);

            // open tabs and set it width to the max (default one), but not affect a local storage change
            // if (isSomeCountAvailable) {
            //     if (!tabsOpened) {
            //         // this.setState({ tabsWidth: DEFAULT_TABS_WIDTH });
            //         // this.openTabs();
            //         // if (this.props.setTabsWidth && typeof this.props.setTabsWidth === 'function') {
            //         //     this.props.setTabsWidth(DEFAULT_TABS_WIDTH);
            //         // }
            //     }
            // }

            return this.setState({
                allowableTabs: sortedConf,
                allowebleLabels: sortedConf.map(({ label }) => label),
                isLoading: false,
            });
        }
        return conf.success;
    };

    resetPreviousTabState = tabName => {
        switch (tabName) {
            case "knowledgeBase":
                return this.props.resetKnowledgeBase();
            case "history":
                return this.props.resetAppealHistory();
        }
    };

    // openTabs = () => {
    //     this.setState({ tabsOpened: true });
    //     if (this.props.setTabsOpened && typeof this.props.setTabsOpened === 'function') {
    //         this.props.setTabsOpened(true);
    //     }
    // };
	
	// toggleTabs = () => {
    //     const newState = !this.state.tabsOpened;
	// 	localStorage.setItem('appeals_tabsOpened', newState);
	// 	this.setState({ tabsOpened: newState });
    //     console.log({props: this.props, newState});
    //     if (this.props.setTabsOpened && typeof this.props.setTabsOpened === 'function') {
    //         this.props.setTabsOpened(newState);
    //     }
	// }

    onCommentCountChange = (count) => {
        const updatedTabs = this.state.allowableTabs.map((tab) => {
            if (tab.label === "comments") {
                return { ...tab, counting: true, countTotal: count };
            }
            return tab;
        });
        this.setState({ allowableTabs: updatedTabs });
    };

    renderTab = props => {
        const { appealId } = this.props.match.params;

        switch (props.match.params.tab) {
            case "knowledgeBase":
                return (
                    <KnowledgeBase
                        unlockAppealForm={this.props.unlockAppealForm}
                        resetAppealType={this.props.resetAppealType}
                        shouldRenderField={this.props.shouldRenderField}
                    />
                );
            case "comments":
                return (
                    <Comments
                        id={this.props.id}
                        objectType="INTERACTION_REQUEST"
                        onOpen={() => this.props.unlockAppealForm(COMMENT_LOCK_SOURCE)}
                        onClose={() => this.props.removeAppealLockSource(COMMENT_LOCK_SOURCE)}
                        isForcedClose={this.props.isLockedByOther}
						isDisabled={this.props.isLockedByOther}
                        initCachedState={this.props.cachedCommentFormState}
                        onStateUpdate={this.props.onCommentFormStateUpdate}
                        onCommentCountChange={this.onCommentCountChange}
                        isCommentFormLoader={this.props.isAppealLockInProgress}
                    />
                );
            case "mailing":
                return (
                    <Mailing
                        unlockAppealForm={this.props.unlockAppealForm}
                        removeAppealLockSource={this.props.removeAppealLockSource}
						isLockedByOther={this.props.isLockedByOther}
                    />
                );
            case "history":
                return (
                    <AppealHistory
                        customHistoryKey="history"
                        customFilters={[
                            { code: "0", label: "Уся історія", default: true },
                            { code: "1", label: "Коментарі", default: false },
                            { code: "2", label: "Мої зміни", default: false },
                        ]}
                        customData={{ appealId }}
                        withoutPagination
                        withReverse
                    />
                );
            default:
                return null;
        }
    };

    renderTabButton = (data, index) => {
        const { allowableTabs } = this.state;
        const { match: { params: { tab: currentTab } }} = this.props;
        const { id, label, counting, countTotal, availabilityOfNew, orderNum, tabActive } = data;
        
        const nextTab = allowableTabs[index + 1];
        let isNextActive = false;
        if (nextTab && nextTab.label === currentTab) {
            isNextActive = true;
        }
        const count = counting && countTotal ? (
            <span className={cx("tab-counter", { availabilityOfNew })}><span className="tab-count">{countTotal}</span></span>
        ) : null;
        return <Tab isNextActive={isNextActive} icon={label} val={label} counter={count} key={label} />;
    };

    getDefaultTabName = () => {
        const { allowableTabs } = this.state;
        let defaultName = allowableTabs.find(({ tabActive }) => tabActive);
        const crumb = this.props.breadcrumbs && this.props.breadcrumbs.find(crumb => crumb.type !== "customer" && +crumb.id === +this.props.id);
        if (crumb && crumb.subTab) {
            defaultName = { label: crumb.subTab };
        }
        return defaultName && defaultName.label;
    };

	// iconHandler = () => {
    //     // const newTabsWidth = this.state.tabsWidth === DEFAULT_TABS_WIDTH ? "width-450" : "width-500";
    //     let newTabsWidth = DEFAULT_TABS_WIDTH;
    //     if (this.state.tabsWidth === DEFAULT_TABS_WIDTH) {
    //         newTabsWidth = "width-450";
    //     }
    //     if (this.state.tabsWidth === "width-450") {
    //         newTabsWidth = "width-0";
    //     }
    //     this.setState({ tabsWidth: newTabsWidth });
    //     localStorage.setItem("appeals_tabsWidth", newTabsWidth);
    //     if (this.props.setTabsWidth && typeof this.props.setTabsWidth === 'function') {
    //         this.props.setTabsWidth(newTabsWidth);
    //     }
    // }


    render() {
        const {
            match,
            location,
            // iconClass,
            // iconHandler,
            data: { tabName },
            tabsCollapseState,
        } = this.props;
        const { allowableTabs, allowebleLabels, isLoading } = this.state;
        const tabsOpened = tabsCollapseState !== 'layout-collapse-collapsed';
        // const iconCls = tabsOpened ? tabsCollapseState : "closed";
        // const iconCls = tabsWidth;
        return (
            <div className={cx("tabs-wrapper appeal-tabs-wrapper", tabsCollapseState, { [`${tabName}ContentWrapper`]: tabName })}>
                {isLoading && <Loader loaderContainerClass="appeal-tabs-loader-container" loaderClass="appeal-tabs-loader-svg" />}
                <>
                    <div className="tabs">
                        <div className="tab-nav">{allowableTabs && allowableTabs.map(this.renderTabButton)}</div>
                        <div className="tab-header-buttons">
                            <div className="button-hover-half-circle" onClick={this.props.toggleTabsTripleCollapseState}>
                                <ReactSVG className="button-icon button-icon-size" src={`/data/svg/tab-right-${tabsCollapseState}.svg`} />
                            </div>
                        </div>
                    </div>
                    <Switch>
                        {allowableTabs && tabsOpened &&  (
                            <RouteWithTabs
                                path="/appeals/:appealId/:tab?"
                                tabs={allowebleLabels}
                                tabPath={"tab"}
                                defaultTabName={this.getDefaultTabName()}
                                match={match}
                                location={location}
                                render={this.renderTab}
                            />
                        )}
                    </Switch>
                </>
            </div>
        );
    }
}

TabContent.propTypes = {
    match: PropTypes.object,
    tabsWidth: PropTypes.string,
    // iconHandler: PropTypes.func,
    // toggleTabs: PropTypes.func,
    data: PropTypes.object,
    refresh: PropTypes.func,
    unlockAppealForm: PropTypes.func,
    onCommentCountChange: PropTypes.func,
};

export default Proxy(TabContent, {
    noRequest: true,
    tabType: data => data && `appeals_${data.appealId}`,
    name: data => data && `appeals_${data.appealId}`,
    queryKey: data => data && `appeals_${data.appealId}_${data.tab}`,
    storeName: data => data && data.tab,
});
